<template>
  <div class="div-componentePCResumenFamiliasVolcados">
    <!-- No existen registros de volcado -->
    <PCInformacionSinRegistros v-if="familias === null || familias.length === 0" />

    <!-- Existen Volcados de Familias -->
    <div
      v-if="familias !== null"
      class="div-listadoVolcadosFamilias"
    >
      <f7-row
        v-for="familia in familias"
        :key="familia.Id"
        class="row-volcadoFamilia"
        @click="VerDetalleVolcadosFamilia(familia.Id)"
      >
        <f7-col width="100">
          <span class="span-nombreFamlia"> {{ familia.NombreFamilia }} </span>
        </f7-col>
        <f7-col
          class="div-cantidadEnvases"
          width="50"
        >
          <img
            alt="iconBox"
            src="@/static/icons/ic_box.svg"
          >
          <span class="span-cantidadEnvases"> {{ familia.CantidadEnvases }} </span>
        </f7-col>
        <f7-col
          width="50"
          class="div-cantidadKilos"
        >
          <span class="span-cantidadKilos"> {{ familia.CantidadKilos }} </span>
          <span class="span-unidadMedidaKilos"> {{ $t('common.kg') }} </span>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCInformacionSinRegistros from '@/components/production/traceability/PCInformacionSinRegistros.vue';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCResumenFamiliasVolcados',
  components: {
    PCInformacionSinRegistros,
  },
  props: {
    /*
    actualizar: {
      type: Number,
      default: null, // Contine la ultima fecha de actualización, al cambiar se dispara la actualizacion de datos.
    },
    */
    activo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      puntoDeVolcado: null,
      familias: null,
      seleccionFamilia: null, // Mantiene el elemento seleccionado.

    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['puntoDeVolcadoSeleccionado']),
    ...mapWritableState(useTraceabilityStore, ['familiaArticuloSeleccionada']),
  },
  watch: {
    activo(val) {
      if (val) {
        this.InicializarComponente();
      }
    },
    /*
    actualizar(val) {
      if (val != null) this.ObtenerResumenFamiliasMercanciaVolcada();
    },
    */
  },
  created() {
    this.InicializarComponente();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.ObtenerPuntoDevolcadoSeleccionado();
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.ObtenerResumenFamiliasMercanciaVolcada();
    },
    ObtenerPuntoDevolcadoSeleccionado() {
      Log(this, this.ObtenerPuntoDevolcadoSeleccionado.name);
      this.puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
    },

    ObtenerResumenFamiliasMercanciaVolcada() {
      Log(this, this.ObtenerResumenFamiliasMercanciaVolcada.name);
      const self = this;
      ConexionTA.callObtenerResumenFamiliasMercanciaVolcada(this.puntoDeVolcado.Id).then((result) => {
        if (result.Valor) {
          self.familias = JSON.parse(result.Mensaje);
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          // LogError(error);
        });
    },

    VerDetalleVolcadosFamilia(idFamilia) {
      Log(this, this.VerDetalleVolcadosFamilia.name);
      [this.seleccionFamilia] = this.familias.filter((f) => f.Id === idFamilia);

      this.familiaArticuloSeleccionada = this.seleccionFamilia;
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/FrmSummaryOfDumpsByFamily');
    },

  },
};
</script>

<style scoped>
.span-nombreFamlia {
  font-size: 18px;
  font-weight: 500;
  line-height: 19px;
  color: #009ba6;
}

.row-volcadoFamilia {
  padding-top: 10px;
  margin-left: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--his-disabled);
}

.span-cantidadEnvases {
  color: var(--his-darkgray);
  font-size: 18px;
  font-weight: 500;
  font-weight: bold;
  margin-left: 10px;
}

.div-cantidadKilos {
  text-align: right;
  padding-right: 25px;
}

.span-cantidadKilos {
  color: var(--his-darkgray);
  font-size: 22px;
  font-weight: 900;
}

.span-unidadMedidaKilos {
  color: #4a4a4a9c;
}

.div-listadoVolcadosFamilias {
  margin-top: 19px;
}

.div-cantidadEnvases {
  margin-top: 10px;
}
</style>
